/** Совпадает с server MAX_HISTORY_PAGE — один запрос, полная выгрузка истории при открытии чата. */
export const DM_HISTORY_MERGE_PAGE = 500;
